/**
 * Sprint Sync Status Service
 * Tracks whether a sprint data sync (ADO + GitHub refresh) is currently in
 * flight in this browser tab, so a global banner can be shown on every page.
 */

class SprintSyncStatusService {
  constructor() {
    this.isSyncing = false;
    this.message = '';
    this.listeners = new Set();
  }

  /**
   * Mark a sync as started.
   * @param {string} [message]
   */
  start(message = 'Sprint data is being refreshed…') {
    this.isSyncing = true;
    this.message = message;
    this.notifyListeners();
  }

  /**
   * Mark the current sync as finished.
   */
  stop() {
    this.isSyncing = false;
    this.message = '';
    this.notifyListeners();
  }

  getState() {
    return { isSyncing: this.isSyncing, message: this.message };
  }

  addListener(callback) {
    this.listeners.add(callback);
  }

  removeListener(callback) {
    this.listeners.delete(callback);
  }

  notifyListeners() {
    const state = this.getState();
    this.listeners.forEach((callback) => {
      try {
        callback(state);
      } catch (error) {
        console.error('[SprintSyncStatus] Listener error:', error);
      }
    });
  }
}

const sprintSyncStatusService = new SprintSyncStatusService();
export default sprintSyncStatusService;
